import {LightCustomer} from "../../interfaces/customers/light-customer";
import {Customer} from "../../interfaces/customers/customer";
import {OpCustomer} from '../../interfaces/operating-plan/op-customer';
import {CalcHelper} from '../../helpers/calc-helper';


export class LightCustomerFactory {

  /**
   *
   * @param customer
   */
  public static fromObject(customer: any): LightCustomer {
    return new class implements LightCustomer {
      id: number = customer.id;
      firstName: string =  customer.first_name;
      lastName: string = customer.last_name;
      customId: number = customer.custom_id;
      fullName: string = customer.full_name;
      name: string = customer.last_name + ' ' + customer.first_name;
      latitude: number = CalcHelper.parseCoordinate(customer.latitude);
      longitude: number = CalcHelper.parseCoordinate(customer.longitude);
      serviceFacilityId: number = customer.service_facility_id;
      route: string = customer.route;
      postalCode: string = customer.postal_code;
      locality: string = customer.locality;
      address: string = customer.address;
      age: number = customer.age;
    };
  }

  /**
   *
   * @param customers
   */
  public static fromArray(customers: any[]): LightCustomer[] {
    return customers.map(_customer => LightCustomerFactory.fromObject(_customer));
  }

  /**
   *
   * @param customer
   */
  public static fromCustomer(customer: Customer): LightCustomer {
    return new class implements LightCustomer {
      address: string = customer.address;
      customId: number = customer.customId;
      firstName: string= customer.firstName;
      fullName: string= customer.fullName;
      name: string = customer.name;
      id: number= customer.id;
      lastName: string= customer.lastName;
      latitude: number = CalcHelper.parseCoordinate(customer.latitude);
      locality: string= customer.locality;
      longitude: number = CalcHelper.parseCoordinate(customer.longitude);
      postalCode: string= customer.postalCode;
      route: string= customer.route;
      serviceFacilityId: number= customer.serviceFacilityId;
      age: number = customer.age;
    };
  }

  /**
   *
   * @param customer
   */
  public static fromOpCustomer(customer: OpCustomer): LightCustomer {
    return new class implements LightCustomer {
      address: string = customer.address;
      customId: number = customer.customId;
      firstName: string= customer.firstName;
      fullName: string= customer.fullName;
      name: string = customer.name;
      id: number= customer.id;
      lastName: string= customer.lastName;
      latitude: number = CalcHelper.parseCoordinate(customer.latitude);
      locality: string= customer.locality;
      longitude: number = CalcHelper.parseCoordinate(customer.longitude);
      postalCode: string= customer.postalCode;
      route: string= customer.route;
      serviceFacilityId: number= customer.serviceFacilityId;
      age: number = customer.age;
    };
  }

}
